import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Grid, Paper, TextField } from "@material-ui/core";
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { withRouter } from 'react-router';
import { checkApiStatus } from '../../utils_v2';
import { ExportMenu, PageLoader } from '../../shared_elements';
import { globalGetService, globalPostService } from '../../../globalServices';
import { checkPermission } from '../../../console_management/utils_v2';
import { trackActivity } from '../../../utils/mixpanel';
import { jetStreamInstance } from '../../../shared/components';

const InsuranceOverview = ({ ownerList }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [start_date, setStartDate] = useState('');
    const [end_date, setEndDate] = useState('');
    const [asset_types, setAsset_types] = useState([]);
    const exportUtilsInvReport = (extension) => {
    let assetsStr = asset_types.map(item => ({ id: item?.id, asset_type: item?.asset_type, asset_name: item?.asset_name }));
        let validationInputs = {};
        validationInputs = {
            ...validationInputs,
            asset_types: assetsStr.length? '' : 'Please select Asset(s)',
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            globalPostService(`console/custom-reports/export-insurance-overview/`,{'file_type':extension,'asset_types':assetsStr})
                .then(response => {
                    setLoading(false);
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Console Management', { page_title: 'Custom Report', item_type: 'Export', event_type: 'Insurance Overview Exported', event_desc: 'Insurance Overview Exported', file_extension: extension })
                        setError({})
                        setAsset_types([])
                    } else {
                        // enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    }
                });
        } else {
            setError(validationInputs)
        }
    }
    const onResetErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }
    return (
        <Paper square>
            <Grid container spacing={0} alignItems='center'>
                <Grid item md={12}>
                    <div className='custom-rpt-card'>
                        <div className='rpt-card-header'>
                            <Grid container spacing={1}>
                                <Grid item md={9}>
                                    <h4>Insurance Overview Report</h4>
                                    <p>Summary of Insurance Coverage Across Fleet. Includes Policy Details, Coverage Periods, Insured Values, Providers and Expiry Alerts for Aircraft and Engines.</p>
                                </Grid>
                                <Grid item md={3}>
                                    {checkPermission('reports', 'custom_reports', 'EXP') ?
                                        <ExportMenu
                                            exportReportFn={(file) => exportUtilsInvReport(file.extension)}
                                            files={[{ title: 'EXCEL', extension: 'xlsx' }]}
                                        /> : null}
                                </Grid>
                            </Grid>
                        </div>
                        <div className='rpt-card-body'>
                            <Grid container spacing={1}>
                                <Grid item md={12}>
                                    <p className='lessor-select'><span onClick={() => { setAsset_types(ownerList);}}>Select All Assets</span>{asset_types.length ? <span style={{ marginLeft: '8px' }} onClick={() => { setAsset_types([]) }} >Remove All Assets</span> : null}</p>
                                    <Autocomplete
                                        options={ownerList}
                                        getOptionLabel={option => option.asset_name}
                                        id='asset_types'
                                        value={asset_types}
                                        labelKey="name"
                                        valueKey="id"
                                        multiple
                                        onChange={(e, data) => {setAsset_types(data);onResetErrorKey('asset_types')}}
                                        renderInput={params => <TextField error={error.asset_types ? true : false} helperText={error.asset_types ? error.asset_types : ''} {...params} label='Assets' margin="normal" placeholder={`Select Asset(s)`} fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Grid>
            </Grid>
            {isLoading ? <PageLoader /> : null}
        </Paper>
    )
}
export default withRouter(InsuranceOverview);